<template>
  <div class="pb-2">
    <ValidationObserver v-slot="{ handleSubmit }" ref="formDemandarSobreOferta">
      <b-form @submit.prevent="handleSubmit(() => (isConfirm = true))">
        <div v-show="!isConfirm">
          <div v-if="oferta">
            <PRow>
              <PCol md="12" lg="6">
                <div class="pl-2 pr-3">
                  <detalle-demanda :oferta-demanda="oferta" />
                </div>
              </PCol>
              <PCol md="12" lg="6">
                <div class="pl-3 pr-3">
                  <b-card-title class="data-form pl-3 pt-4">{{
                    $t("title.solicitudDemandada")
                  }}</b-card-title>
                  <PRow>
                    <PCol v-if="isClientesLoaded">
                      <div v-if="clientes.length === 1">
                        <PDataLine
                          class="mb-0"
                          :value="{
                            cliente: clienteSelected?.desCliente,
                          }"
                          :fields="{
                            cliente: { title: $t('label.cliente') },
                          }"
                        />
                      </div>
                      <div v-else>
                        <PFormSelect
                          v-model="demandaParams.pkCliente"
                          :options="clientes"
                          optionValue="id"
                          optionText="desCliente"
                          :label="$t('label.cliente')"
                          :placeholder="$t('option.select')"
                          @change="searchSaldosActuales"
                        />
                      </div>
                    </PCol>
                  </PRow>
                  <PRow>
                    <PCol v-if="delegaciones.length === 1">
                      <PDataLine
                        class="mb-0"
                        :value="{
                          delegacion: oferta.clientexdel.delegacion.desDelegacion,
                          divisa: divisa.simbolo + ' ' + divisa.codDivisa,
                        }"
                        :fields="{
                          delegacion: { title: $t('label.delegacion') },
                          divisa: { title: $t('label.divisa') },
                        }"
                        :showSeparators="true"
                      />
                    </PCol>
                    <PCol class="mt-1" v-else>
                      <PFormSelect
                        v-model="demandaParams.pkDelegacion"
                        :options="delegaciones"
                        optionValue="id"
                        optionText="desDelegacion"
                        :label="$t('label.delegaciones')"
                        :placeholder="$t('option.select')"
                        @change="searchSaldosActuales"
                      />
                    </PCol>
                  </PRow>
                  <PRow>
                    <PCol
                      class="mt-1"
                      md="6"
                      v-if="clienteSelected !== null && clienteSelected?.pais.hasTransportadora"
                    >
                      <PFormSelect
                        v-model="demandaParams.pkTransportadora"
                        :options="transportadoras"
                        optionValue="id"
                        optionText="descripcion"
                        :label="$t('label.transportadora.destino')"
                        :placeholder="$t('option.select')"
                        :rules="'required'"
                      />
                    </PCol>
                  </PRow>

                  <PRow v-if="divisa && !oferta.clientexdel.cliente.fakeCerts">
                    <PCol>
                      <PDataLine
                        class="mb-0"
                        :value="{
                          saldo:
                            divisa.simbolo + ' ' + filterNumber(saldoRestante, 2).toLocaleString(),
                          total:
                            divisa.simbolo + ' ' + filterNumber(saldoOfertar, 2).toLocaleString(),
                        }"
                        :fields="{
                          saldo: { title: $t('label.saldo.restante') },
                          total: { title: $t('label.total.demandar') },
                        }"
                        :widthContent="true"
                        :showSeparators="true"
                      />
                    </PCol>
                  </PRow>

                  <PRow>
                    <PCol>
                      <PTableSimple :fields="fields_PTableSimple" :items="detallesSaldo">
                        <template #denominacion="{ item }">
                          {{ item.calidadDenominacion.denominacion.codDenominacion }}
                          {{ item.calidadDenominacion.desCalidad }}
                        </template>
                        <template
                          #saldoActual="{ item }"
                          v-if="clienteSelected && !clienteSelected.fakeCerts"
                        >
                          {{ filterNumber(item.saldoActual, 2) }}
                        </template>
                        <template #calidadDenominacion="{ item, showExtend }">
                          <div @click="showExtend" class="denominacion-importe">
                            {{ divisa.simbolo }}
                            {{ filterNumber(item.calidadDenominacion.importe, 2) }}
                          </div>
                        </template>
                        <template #extend="{ item, index }">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="`required|min_value:0|valid-denomination:${item.calidadDenominacion.denominacion.numValue}`"
                            :name="`cantidad-denominacion_${index}`"
                          >
                            <b-card class="input-card mt-2">
                              <b-card-body>
                                <b-row>
                                  <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                    <b-form-group>
                                      <b-input
                                        type="number"
                                        min="0"
                                        :max="item.saldoMaximoOfertar"
                                        :step="item.calidadDenominacion.denominacion.numValue"
                                        v-model="item.calidadDenominacion.importe"
                                        :name="`cantidad-denominacion_${index}`"
                                        :id="`cantidad-denominacion_${index}`"
                                        :state="errors[0] ? false : null"
                                        :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                      />
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                                <b-input
                                  type="range"
                                  min="0"
                                  :max="item.saldoMaximoOfertar"
                                  :step="item.calidadDenominacion.denominacion.numValue"
                                  v-model="item.calidadDenominacion.importe"
                                  class="mt-1"
                                ></b-input>
                              </b-card-body>
                            </b-card>

                            <b-form-invalid-feedback
                              :id="`cantidad-denominacion-feedback_${index}`"
                              class="d-block"
                            >
                              {{ errors[0] }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </template>
                      </PTableSimple>
                    </PCol>
                  </PRow>

                  <PRow v-if="enableFechaExpiracion">
                    <PCol md="8">
                      <b-form-group>
                        <label class="label-form d-block" for="datepicker_fechaExpiracion">{{
                          $t("label.fecha.expiracion")
                        }}</label>
                        <b-form-datepicker
                          id="datepicker_fechaExpiracion"
                          :locale="locale"
                          :label-calendar="$t('label.calendar')"
                          :label-close-button="$t('label.close_button')"
                          :label-current-month="$t('label.current_month')"
                          :label-help="$t('label.help')"
                          :label-nav="$t('label.nav')"
                          :label-next-decade="$t('label.next_decade')"
                          :label-next-month="$t('label.next_month')"
                          :label-next-year="$t('label.next_year')"
                          :label-no-date-selected="$t('label.no_date_selected')"
                          :label-prev-decade="$t('label.prev_decade')"
                          :label-prev-month="$t('label.prev_month')"
                          :label-prev-year="$t('label.prev_year')"
                          :label-reset-button="$t('label.reset_button')"
                          :label-today="$t('label.today')"
                          :label-today-button="$t('label.today_button')"
                          v-model="demandaParams.fecExpirar"
                          :min="minFecExpirar"
                        />

                        <div class="textError" v-if="!esFechaHoraCorrectos">
                          {{ $t("error.fechaDebeSerMayorHoyALas17") }}
                        </div>
                      </b-form-group>
                    </PCol>
                    <PCol md="4">
                      <b-form-group>
                        <label class="label-form d-block" for="select-hora-expiracion">{{
                          $t("label.hora.expiracion")
                        }}</label>
                        <b-time
                          id="select-hora-expiracion"
                          name="select-hora-expiracion"
                          v-model="horaExpiracion"
                          aria-describedby="fecha-hora-feedback"
                          :hide-header="true"
                        />
                      </b-form-group>
                    </PCol>
                  </PRow>
                  <PRow>
                    <PCol col="6" md="4">
                      <label class="label-form" for="coste">{{ $t("label.coste") }}</label>
                      <span class="data-form" id="coste">
                        {{ $t(`label.coste.${oferta.coste.codParametro}`) }}
                      </span>
                    </PCol>
                    <PCol col="6" md="4" v-if="oferta.clientexdel.cliente.pais.hasTasa">
                      <label class="label-form" for="tasa">{{ $t("label.tasa") }}</label>
                      <span
                        v-if="!oferta.clientexdel.cliente.pais.hasTasaEnteros"
                        class="data-form"
                        id="tasa"
                        >{{ filterNumber(oferta.numTasa, 5) }} %</span
                      >
                      <span
                        v-if="oferta.clientexdel.cliente.pais.hasTasaEnteros"
                        class="data-form"
                        id="tasa"
                      >
                        {{ Math.round(oferta.numTasa * 100000) }} x 10.000
                      </span>
                    </PCol>
                  </PRow>
                  <PRow>
                    <PCol md="6" v-if="clienteSelected?.pais.admiteAnonimo">
                      <PFormSwitch
                        v-model="demandaParams.checkAnonimo"
                        :label="$t('label.demanda.anonima')"
                      />
                    </PCol>
                    <PCol md="6" v-if="!clienteSelected?.pais.hasAprobacionAutomaticaOferta">
                      <PFormSwitch
                        v-model="demandaParams.checkParcial"
                        :label="$t('label.parcial')"
                      />
                    </PCol>
                  </PRow>
                  <PRow>
                    <PCol>
                      <label class="label-form d-block" for="observacionesDemanda">{{
                        $t("label.observaciones")
                      }}</label>
                      <textarea
                        class="textarea"
                        id="observacionesDemanda"
                        v-model="demandaParams.observacionesDemanda"
                        name="observacionesOferta"
                        type="text"
                      />
                    </PCol>
                  </PRow>
                </div>
              </PCol>
            </PRow>
            <PRow>
              <PCol class="buttons_DemandarSobreOferta">
                <PButton @click="cancel" variant="secondary">{{ $t("label.cancelar") }}</PButton>
                <PButton @click="handleSubmit(() => (isConfirm = true))" :disabled="!estaTodoOk">
                  {{ $t("label.demandar") }}
                </PButton>
              </PCol>
            </PRow>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
    <div v-if="isConfirm">
      <PConfirm
        :textButtonAccept="$t('label.demandar')"
        @accept="demandar"
        @cancel="isConfirm = false"
      >
        <template #title>
          {{ textoTituloConfirm }}
        </template>
        <template #description>
          <span class="label-21">
            {{ $t("label.solicitar.fondos") }}
            <span class="font-weight-bold"> {{ oferta.clientexdel.delegacion.desDelegacion }}</span>
          </span>
          <br />
          <br />
          <span v-if="clienteSelected?.pais.hasAprobacionAutomaticaOferta" class="label-21">
            {{ $t("label.transferencias.disclaimer") }}
          </span>
          <span v-else class="label-21">{{ $t("label.demanda.disclaimer") }}</span>
        </template>
        <template #content>
          <PDataLine
            v-if="divisa"
            :value="{
              total: divisa.simbolo + ' ' + filterNumber(saldoOfertar, 2),
            }"
            :fields="{
              total: { title: $t('label.total.demandar') },
            }"
            :widthContent="true"
          />
        </template>
      </PConfirm>
    </div>
  </div>
</template>
<script lang="ts">
import { Action, Getter } from "vuex-class";
import { EventBus } from "@/event-bus";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDemandaParams, ISaldoActualParams } from "@/services";
import { Locale } from "@/store";
import VueFilters from "@/vue-filters";

import {
  ICliente,
  IDelegacion,
  IDetalleOferta,
  IDetallesSaldo,
  IDivisa,
  IOfertaDemanda,
  ISaldo,
} from "@/entities";
import DetalleDemanda from "@/pages/transferencias/common/OfertaDemandaDetalle.vue";
import VueMethods from "@/vue-methods";
import { ITransportadora } from "@/entities/centros-efectivo-backend/transportadora";

@Component({
  name: "demanda-privada-modal",
  components: {
    DetalleDemanda,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [VueFilters, VueMethods],
})
export class DemandarSobreOferta extends Vue {
  @Prop({ required: true }) oferta!: IOfertaDemanda;
  @Prop({ required: true }) divisa!: IDivisa;

  @Action("fetchSaldoActual") fetchSaldoActual!: (
    params?: ISaldoActualParams
  ) => Promise<ISaldo | undefined>;
  @Getter("getLocale") locale!: Locale;
  @Getter("getClienteSelected") getClienteSelected!: ICliente;

  isConfirm = false;
  saldoActual: ISaldo | null = null;
  transportadoras: ITransportadora[] | null = [];
  detallesSaldo: IDetallesSaldo[] | undefined = [];
  saldoDisponible: number | undefined = 0;
  demandaParams: IDemandaParams = {
    numCantidad: 0,
    fecExpirar: new Date(),
    checkAnonimo: false,
    checkParcial: false,
    coste: 0,
    pkDivisa: 0,
    pkCliente: 0,
    pkDelegacion: 0,
    pkTransportadora: null,
    detallesDemanda: [],
    pkDelegaciones: [],
  };
  minFecExpirar: Date = new Date();
  horaExpiracion = "17:00";
  clientes: ICliente[] = [];
  isClientesLoaded = false;

  limpiar(): void {
    this.demandaParams.checkAnonimo = false;
    this.demandaParams.checkParcial = false;
    this.fechaDefecto();
  }

  async mounted(): Promise<void> {
    this.fechaDefecto();
    await this.fetchClientesByDivisa();

    if (this.clienteSelected) {
      this.demandaParams.checkAnonimo = false;
      this.demandaParams.checkParcial = false;

      this.demandaParams.pkOferta = this.oferta.id;
      this.demandaParams.coste = this.oferta.coste?.id;
      this.demandaParams.pkDelegacion = this.oferta.clientexdel.delegacion.id;
      this.demandaParams.pkDivisa = this.divisa.id;
      this.demandaParams.numTasa = this.oferta.numTasa;
      this.demandaParams.detallesDemanda = [];

      await this.searchSaldosActuales();
    }
  }

  fechaDefecto(): void {
    const currentDate = new Date();

    const formatDate = (date: Date): string =>
      `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}`;

    const fechaExpiracion = formatDate(currentDate);
    const horaExpiracion = this.clienteSelected?.expirationTime ?? "17:00:00";

    const fechaHoraExpiracion = new Date(`${fechaExpiracion}T${horaExpiracion}`);

    if (currentDate.getTime() > fechaHoraExpiracion.getTime()) {
      fechaHoraExpiracion.setDate(fechaHoraExpiracion.getDate() + 1);
    }

    this.demandaParams.fecExpirar = fechaHoraExpiracion;
  }

  async fetchClientesByDivisa(): Promise<void> {
    let idDelegacion = this.oferta.clientexdel.delegacion.id;
    let idDivisa = this.divisa.id;

    const res = await this.$services.clientes._fetchAllClienteXDelegacionAndDivisa(
      idDelegacion,
      idDivisa
    );
    this.clientes =
      res?.filter(
        (cliente) => cliente.id != this.oferta.clientexdel.cliente.id && cliente.active
      ) ?? [];

    this.demandaParams.pkCliente =
      this.clientes.find((c) => c.id === this.getClienteSelected?.id)?.id ?? this.clientes[0].id!;
    this.isClientesLoaded = true;
  }

  get clienteSelected(): ICliente | null {
    return this.clientes.find((cliente) => cliente.id === this.demandaParams.pkCliente) ?? null;
  }

  async searchTransportadoras(): Promise<void> {
    if (this.clienteSelected) {
      const res = await this.$services.transportadoras.fetchAllTransportadorasByCodPaisCorto(
        this.clienteSelected.pais.codPaisCorto
      );
      if (res) {
        this.transportadoras = res;
      }
    }
  }

  get delegaciones(): IDelegacion[] {
    return (
      this.oferta.ubicaciones
        ?.map((ubicacion) => ubicacion.delegacion)
        .filter((delegacion) => delegacion.active)
        .sort((a, b) => this.sortAscending(a, b, "desDelegacion")) ?? []
    );
  }

  get textoTituloConfirm(): string {
    return this.$t("title.demanda.confirm") + "";
  }

  get fields_PTableSimple(): { key: string; label: string }[] {
    if (this.oferta.clientexdel?.cliente?.fakeCerts) {
      return [
        { key: "denominacion", label: this.$t("label.denominacion") },
        { key: "calidadDenominacion", label: this.$t("label.ofertado") },
      ];
    } else {
      return [
        { key: "denominacion", label: this.$t("label.denominacion") },
        { key: "saldoActual", label: this.$t("label.disponible") },
        { key: "calidadDenominacion", label: this.$t("label.demandado") },
      ];
    }
  }

  get saldoRestante(): number {
    return Number(this.saldoDisponible) - Number(this.saldoOfertar);
  }

  get saldoOfertar(): number {
    let sumaImportes = 0;
    this.detallesSaldo?.forEach((detalleSaldo) => {
      if (detalleSaldo.calidadDenominacion?.importe) {
        sumaImportes = Number(sumaImportes) + Number(detalleSaldo.calidadDenominacion?.importe);
      }
    });

    return sumaImportes;
  }

  async searchSaldosActuales(): Promise<void> {
    this.limpiar();
    this.saldoDisponible = 0;
    this.detallesSaldo = [];

    if (this.clienteSelected && this.demandaParams?.pkDelegacion && this.divisa) {
      if (!this.clienteSelected?.fakeCerts) {
        const res = await this.fetchSaldoActual({
          pkCliente: this.demandaParams?.pkCliente,
          pkDelegacion: this.demandaParams?.pkDelegacion,
          pkDivisa: this.divisa.id,
        });

        if (res) {
          this.saldoActual = res;
          if (this.saldoActual) {
            this.saldoDisponible = this.saldoActual.saldoActual;
            this.oferta?.detallesOferta?.forEach((detalleOferta: IDetalleOferta) => {
              const detallesSaldoQueEstanEnOferta = this.saldoActual?.detallesSaldo?.filter(
                (detalleSaldo: IDetallesSaldo) => {
                  return (
                    detalleSaldo.calidadDenominacion?.id === detalleOferta.soCalidadDenominacion.id
                  );
                }
              );

              detallesSaldoQueEstanEnOferta?.forEach((detallesSaldoOfertados) => {
                detallesSaldoOfertados.saldoMaximoOfertar = detalleOferta.cantidadDisponible;
                this.detallesSaldo?.push(detallesSaldoOfertados);
              });
            });

            this.detallesSaldo?.forEach((detalleSaldo) => {
              this.$set(detalleSaldo.calidadDenominacion!, "importe", 0);
            });
          }
        } else {
          EventBus.$emit("p-toast", { variant: "danger", message: res });
        }
      } else {
        this.oferta?.detallesOferta?.forEach((detalleOferta: IDetalleOferta) => {
          this.detallesSaldo?.push({
            calidadDenominacion: {
              denominacion: detalleOferta.soCalidadDenominacion.denominacion,
              codCalidad: detalleOferta.soCalidadDenominacion.codCalidad,
              desCalidad: detalleOferta.soCalidadDenominacion.desCalidad,
              importe: 0,
              id: detalleOferta.soCalidadDenominacion.id,
              cantidad: 0,
              importeSelected: false,
              cantidadSelected: false,
            },
            saldoActual: 0,
            saldoMaximoOfertar: detalleOferta.cantidadDisponible,
          });
        });

        this.detallesSaldo?.forEach((detalleSaldo) => {
          this.$set(detalleSaldo.calidadDenominacion!, "importe", 0);
        });
      }
    }
    if (this.clienteSelected?.pais.hasTransportadora) {
      await this.searchTransportadoras();
    }
  }

  cancel(): void {
    this.$emit("cancel");
    this.resetData();
  }

  resetData(): void {
    this.demandaParams.pkOferta = undefined;
    this.demandaParams.observacionesDemanda = "";
  }

  async demandar(): Promise<void> {
    let totalNumCantidad = 0;
    this.detallesSaldo?.forEach((ds) => {
      if (ds.calidadDenominacion && ds.calidadDenominacion.importe > 0) {
        this.demandaParams?.detallesDemanda?.push({
          calidadDenominacion: ds.calidadDenominacion,
          numCantidad: parseFloat(ds.calidadDenominacion?.importe + ""),
        });
      }
      totalNumCantidad = totalNumCantidad + parseFloat(ds.calidadDenominacion?.importe + "");
    });
    this.demandaParams.numCantidad = totalNumCantidad;

    const fecExpirar = new Date(this.demandaParams.fecExpirar);
    fecExpirar.setTime(fecExpirar.getTime() + fecExpirar.getTimezoneOffset() * 60 * 1000);
    const horaMin: string[] = this.horaExpiracion.split(":");
    fecExpirar.setHours(parseInt(horaMin[0]));
    fecExpirar.setMinutes(parseInt(horaMin[1]));

    this.demandaParams.fecExpirar = fecExpirar;
    this.demandaParams.hasAprobacionAutomatica =
      this.clienteSelected?.pais.hasAprobacionAutomaticaOferta ?? false;
    this.$emit("action", { action: "demandarSobreOfertaConfirmed", data: this.demandaParams });
  }

  get esFechaHoraCorrectos(): boolean {
    let returnTemp = false;
    const horaMin: string[] = this.horaExpiracion.split(":");
    const fechaComprobar = new Date(this.demandaParams.fecExpirar);
    fechaComprobar.setTime(
      fechaComprobar.getTime() + fechaComprobar.getTimezoneOffset() * 60 * 1000
    ); //ajustamos la hora a la zona horaria del offset

    fechaComprobar?.setHours(parseInt(horaMin[0]));
    fechaComprobar?.setMinutes(parseInt(horaMin[1]));
    fechaComprobar?.setSeconds(0);
    fechaComprobar?.setMilliseconds(0);
    const fechaHoy17 = new Date();
    fechaHoy17.setHours(17);
    fechaHoy17.setMinutes(0);
    fechaHoy17.setSeconds(0);
    fechaHoy17.setMilliseconds(0);
    if (new Date().getTime() < fechaHoy17.getTime()) {
      // comprobamos si hoy es antes de las 17
      if (fechaComprobar && fechaComprobar?.getTime() >= fechaHoy17.getTime()) {
        //comprobamos si la fecha puesta es mayor o igual hoy a las 17
        returnTemp = true;
      }
    } else if (fechaComprobar && fechaComprobar?.getTime() >= fechaHoy17.getTime() + 86400000) {
      //comprobamos que la fecha sea mayor o igual que la de mañana a las 17.00
      returnTemp = true;
    }
    return returnTemp;
  }
  get estaTodoOk(): boolean {
    //revisamos los importes
    let totalNumMax = 0;
    this.detallesSaldo?.forEach((ds) => {
      if (ds.calidadDenominacion) totalNumMax = totalNumMax + parseInt(ds.saldoMaximoOfertar + "");
    });

    let totalNumCantidad = 0;
    this.detallesSaldo?.forEach((ds) => {
      if (ds.calidadDenominacion)
        totalNumCantidad = totalNumCantidad + parseInt(ds.calidadDenominacion?.importe + "");
    });
    return this.esFechaHoraCorrectos && totalNumCantidad > 0 && totalNumCantidad <= totalNumMax;
  }

  get enableFechaExpiracion(): boolean {
    return (
      !this.clienteSelected?.pais.hasTransportadora &&
      !this.clienteSelected?.pais.hasAprobacionAutomaticaOferta
    );
  }
}
export default DemandarSobreOferta;
</script>
<style scoped lang="scss">
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
  cursor: pointer;
}
.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}
.textError {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.buttons_DemandarSobreOferta {
  display: flex;
  justify-content: center;
}
.textarea {
  height: 100px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}
</style>
